/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

export * from "./JsonApiService";
export * from "./Model";
export * from "./Document";
export * from "./ResourceIdentifier";
export * from "./Resource";



// WEBPACK FOOTER //
// ./src/utils/json-api/index.ts